import { MessageBox } from 'element-ui'
const Confirm = MessageBox.confirm;

// 封装Alert
export function $Alert(title="是否确认此操作？") {
    const res = new Promise((resolve) => {
        Confirm(title, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            resolve(true)
        }).catch(() => {
            resolve(false)
        });
    })
    return res
}
// 封装自定义弹框
export function $Alertnew(title="是否确认此操作？") {
    const res = new Promise((resolve) => {
        Confirm(title, '提示', {
			distinguishCancelAndClose: true,
            confirmButtonText: '确定',
            cancelButtonText: '前往结算账单',
            type: 'warning'
        }).then(() => {
            resolve('1')
        }).catch(action => {
			action === 'cancel'? resolve('0'):resolve('2')
        });
    })
    return res
}

// 表单提交验证
export function formVali(formRefs) {
    const res = new Promise((resolve) => {
        formRefs.validate((valid) => {
            if (valid) {
                resolve(true)
            } else {
                resolve(false)
            }
        })
    })
    return res
}

// 格式化表计类型
export function funFmtDevType(id) {
    let str;
    id = Number(id);
    switch (id) {
        case 1:
            str = '当量温控器'
            break;
        case 2:
            str = '计量风柜'
            break;
        case 3:
            str = '热量表'
            break;
        default:
            str = ''
            break;
    }
    return str
}

// 格式化表计在线状态
export function funFmtOnlineStatus(id) {
    let str;
    id = Number(id);
    switch (id) {
		case 0:
		    str = '离线'
		    break;
        case 1:
            str = '在线'
            break;
        case 2:
            str = '离线'
            break;
        default:
            str = ''
            break;
    }
    return str
}

// 格式化表计热量表在线状态
export function funFmtRlbOnlineStatus(id) {
    let str;
    id = Number(id);
    if(id==0)
    {
        str = '正常运转'
        return str;
    }
    var arr = id.toString(2).split("");
    str = ""
    for (let i=1; i<=arr.length; i++){
        if (i==1)
        {
            if(arr[arr.length-i]=='1')
                    str += '短路+'
        }
        if (i==2)
        {
            if(arr[arr.length-i]=='1')
                    str += '断路+'
        }
        if (i==3)
        {
            if(arr[arr.length-i]=='1')
                    str += '无水+'
        }
        if (i==4)
        {
            if(arr[arr.length-i]=='1')
                    str += '坏+'
        }
        if (i==5)
        {
            if(arr[arr.length-i]=='1')
                    str += '过流+'
        }
        if (i==6)
        {
            if(arr[arr.length-i]=='1')
                    str += '低压+'
        }
    }
    if(str.substr(str.length-1,str.length)=="+")
    {
            str=str.substr(0,str.length-1);
    }
    return str
    /*
    // switch (id) {
    //     case 1:
    //         str = '短路'
    //         break;
    //     case 2:
    //         str = '断路'
    //         break;
    //     case 4:
    //         str = '无水'
    //         break;
    //     case 8:
    //         str = '坏'
    //         break;
    //     case 16:
    //         str = '过流'
    //         break;
    //     case 32:
    //         str = '低压'
    //         break;
    //     case 0:
    //         str = '正常运转'
    //         break;
    //     default:
    //         str = ''
    //         break;
    // }
    if(str.length >0)
    {
        str=str.substring(str.lastIndexOf("+")+1);
    }
    return str
    */
}

// 格式化温控器面板参数
/*
    风盘控制 VS 风柜控制： 
    1、键盘锁定[1：08锁风速设置]

*/ 
export function funFmtWKQParmas(status) {
    return {
        //  开关机
        powerOn: function() {
            switch (status) {
                case 0:
                    return '关机'
                case 1:
                    return '开机'
                default:
                    return ''
            }
        },
        // 模式操作
        settingMode: function() {
            switch (status) {
                case 1:
                    return '制冷'
                case 4:
                    return '风扇'
                case 8:
                    return '制热'
                default:
                    return ''
            }
        },
        // 风速操作
        settingSpeed: function() {
            switch (status) {
                case 2:
                    return '低风速'
                case 4:
                    return '中风速'
                case 8:
                    return '高风速'
                case 128:
                    return '自动风速'
                default:
                    return ''
            }
        },
        // 键盘锁定
        setting_key_lock: function() {
            switch (status) {
                case 0:
                    return '解除锁定'
                case 1:
                    return '锁开关机'
                case 2:
                    return '锁温度设置'
                case 4:
                    return '锁模式操作'
                case 8:
                    return '锁风速设置'
                case 128:
                    return '锁定面板'
                default:
                    return ''
            }
        },
        // 来电启动方式
        setting_op_at_acback: function() {
            switch (status) {
                case 0:
                    return '来电保持关机'
                case 1:
                    return '来电保持掉电前状态'
                case 2:
                    return '来电强制开机'
                default:
                    return ''
            }
        },
        // 风扇模式使能
        setting_enable_fanonly: function() {
            switch (status) {
                case 0:
                    return '风扇模式禁用'
                case 1:
                    return '允许风扇模式'
                default:
                    return ''
            }
        }
    }
}

export function getHouseName(data) {
    let a = [];
    data.map(v=>{
        a.push(v.housename)
    })
    return a.join(" / ")
}
export function getHouseNames(data) {
    let a = [];
    data.map(v=>{
		let str=''
		v.moduleidlist.map(j=>{
			str=str + j.modulename	
		})
		str = str + v.housename
		a.push(str)
        // a.push(v.housename)
    })
    return a.join(" / ")
}

// 获取唯一ID
export function getGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

// 获取当前时间
export function FormatDate(fmt) {
    let date = new Date();
    var o = {
        "M+": date.getMonth() + 1, //月份 
        "d+": date.getDate(), //日 
        "H+": date.getHours(), //小时 
        "m+": date.getMinutes(), //分 
        "s+": date.getSeconds(), //秒 
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度 
        "S": date.getMilliseconds() //毫秒 
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}
// 获取前一天时间
export function FormatPrevDate(fmt) {
    let curDate = new Date()
    let date = new Date(curDate.getTime() - (24 * 60 * 60 * 1000));
    var o = {
        "M+": date.getMonth() + 1, //月份 
        "d+": date.getDate(), //日 
        "H+": date.getHours(), //小时 
        "m+": date.getMinutes(), //分 
        "s+": date.getSeconds(), //秒 
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度 
        "S": date.getMilliseconds() //毫秒 
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}
// 获取后一天时间
export function FormatNextDate(fmt) {
    let curDate = new Date()
    let date = new Date(curDate.getTime() + (24 * 60 * 60 * 1000));
    var o = {
        "M+": date.getMonth() + 1, //月份 
        "d+": date.getDate(), //日 
        "H+": date.getHours(), //小时 
        "m+": date.getMinutes(), //分 
        "s+": date.getSeconds(), //秒 
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度 
        "S": date.getMilliseconds() //毫秒 
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}
//时间戳转换方法    date:时间戳数字
export function FormatDateStr(data) {
    let date = new Date(data);
    let YY = date.getUTCFullYear() + '-';
    let MM = (date.getUTCMonth() + 1 < 10 ? '0' + (date.getUTCMonth() + 1) : date.getUTCMonth() + 1) + '-';
    let DD = (date.getUTCDate() < 10 ? '0' + (date.getUTCDate()) : date.getUTCDate());
    let hh = (date.getUTCHours() < 10 ? '0' + date.getUTCHours() : date.getUTCHours()) + ':';
    let mm = (date.getUTCMinutes() < 10 ? '0' + date.getUTCMinutes() : date.getUTCMinutes()) + ':';
    let ss = (date.getUTCSeconds() < 10 ? '0' + date.getUTCSeconds() : date.getUTCSeconds());
    return YY + MM + DD + " " + hh + mm + ss;
}

// 获取星期
export function FormatDateDay() {
    const weekday=["星期日","星期一","星期二","星期三","星期四","星期五","星期六"]
    let date = new Date();
    let myddy = date.getDay()
    return weekday[myddy];
}

// 获取唯一ID
export function Guid() {
    function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }
    return (S4() + S4() + "" + S4() + "" + S4() + "" + S4() + "" + S4() + S4() + S4());
}

// 根据房间信息拼接具体位置
export function fmtHouseInfo(housename, moduleidlist) {
    if (!moduleidlist) {
        return housename
    }
    let str = '';
    JSON.parse(moduleidlist).map(v=>{
        str += v.modulename
    })
    str += housename;
    return str
}

export function getMaxHeigth() {
    // 容器高度 - 导航高度 - 头部查询高度 - 容器上下pad+margin高度 - 分页高度
    let warperHeight = document.getElementsByClassName('wrapper-box')[0].offsetHeight
    let breadcrumbHeight = document.getElementsByClassName('tags')[0].offsetHeight
    let handFormDom = document.getElementsByClassName('handleForm')[0]
    let handleForm = handFormDom ? handFormDom.offsetHeight : 0;
    return (warperHeight - handleForm - breadcrumbHeight - 40 - 50)
}

// 机房监控省去varConfig的filter
export function computedUtil2(value, data) {
    if(isNaN(value)) return 0
    
    value = Number(value)
    let arr = data
    if (arr.length > 0) {
        let { input_max, input_min, output_max, output_min, display_format, linear_conversion } = arr[0]
        let unit = arr[0].var_unit
        display_format = display_format === 0 ? 2 : display_format
        // 计算工程变量
        // if (linear_conversion && !isNaN(input_max) && !isNaN(input_min) && !isNaN(output_max) && !isNaN(output_min)) {
            
        //     if ((input_max - input_min) !== 0) {
        //         value = ((value - input_min) * (output_max - output_min)) / (input_max - input_min) + output_min
        //     }
            
        // }
        if (unit === '0' || unit === '' || unit === null || isNaN(unit)) {
			if(JSON.stringify(value).indexOf('.') ==1){
				return value.toFixed(display_format);
			}else{
				return value.toString()
			}
			
        } else {
			if(JSON.stringify(value).indexOf('.')== 1){
				return value.toFixed(display_format);
			}else{
				return value.toString()
			}
            // return (unit * value).toFixed(display_format);
			// return value.toPrecision(display_format);
			// return value.toString()
        }
    }
    return value
}

// 机房监控省去varConfig的filter
export function computedUtil1(value, data) {
    let arr = data
    if (arr.length > 0) {
        let { input_max, input_min, output_max, output_min, display_format, linear_conversion } = arr[0]
        let unit = arr[0].var_unit
        display_format = display_format === 0 ? 2 : display_format
        // 计算工程变量
        if (linear_conversion && !isNaN(input_max) && !isNaN(input_min) && !isNaN(output_max) && !isNaN(output_min)) {
            if ((input_max - input_min) !== 0) {
                value = (value - output_min) * (input_max - input_min) / (output_max - output_min) + input_min
            }
        }
        if (unit === '' || unit === null || isNaN(unit)) {
            return parseInt(value);
        } else {
            // return parseInt(value / unit);
			 return parseInt(value);
        }
    }
    return value
}

export function FormatUTCDate(data, fmt) {
    let date = new Date(data);
    var o = {
        "M+": date.getUTCMonth() + 1, //月份 
        "d+": date.getUTCDate(), //日 
        "H+": date.getUTCHours(), //小时 
        "m+": date.getUTCMinutes(), //分 
        "s+": date.getUTCSeconds(), //秒 
        "q+": Math.floor((date.getUTCMonth() + 3) / 3), //季度
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getUTCFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}


// 时间搓转换格式
export function FormatTimeDate(time, fmt) {
    let date = new Date(time);
    var o = {
        "M+": date.getMonth() + 1, //月份 
        "d+": date.getDate(), //日 
        "H+": date.getHours(), //小时 
        "m+": date.getMinutes(), //分 
        "s+": date.getSeconds(), //秒 
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度 
        "S": date.getMilliseconds() //毫秒 
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}


//获取所选月份的第一天
export function getCurrentMonthFirst(date) {
    var startdate = new Date(date);
    var time = startdate.setDate(1);
    return FormatTimeDate(time, "yyyy-MM-dd");
}

//获取所选月份的最后一天
export function getCurrentMonthLast(date) {
    var endDate = new Date(date);
    var month = endDate.getMonth();
    var nextMonth = ++month;
    var nextMonthFirstDay = new Date(endDate.getFullYear(), nextMonth, 1);
    var oneDay = 1000 * 60 * 60 * 24;
    var time = nextMonthFirstDay - oneDay
    return FormatTimeDate(time, "yyyy-MM-dd");
};
// 热量表
export function reliangbiaoInfo(data) {
    let obj = {};
    obj._data = data;   //  保存原始数据
    // cool = cool.toString(10)
	//累计冷量
	let cool
	if(obj._data.cooling_capacity_unit){
		cool = obj._data.cooling_capacity_unit.toString(16)
	}else{
		cool = 'hh'
	}
	if(cool =='2' ){
		obj.coolingCapacity = data.cooling_capacity + "(Wh)"
	}else if(cool == '3'){
		obj.coolingCapacity = data.cooling_capacity + "(10Wh)"
	}else if(cool == '4'){
		obj.coolingCapacity = data.cooling_capacity + "(100Wh)"
	}else if(cool == '5'){
		obj.coolingCapacity = data.cooling_capacity + "(KWh)"
	}else if(cool == 'b'){
		obj.coolingCapacity = data.cooling_capacity + "(KJ)"
	}else if(cool == 'c'){
		obj.coolingCapacity = data.cooling_capacity + "(10KJ)"
	}else if(cool == 'd'){
		obj.coolingCapacity = data.cooling_capacity + "(100KJ)"
	}else if(cool == 'e'){
		obj.coolingCapacity = data.cooling_capacity + "(MJ)"
	}else if(cool == 'f'){
		obj.coolingCapacity = data.cooling_capacity + "(10MJ)"
	}else if(cool == '10'){
		obj.coolingCapacity = data.cooling_capacity + "(100MJ)"
	}else if(cool == '11'){
		obj.coolingCapacity = data.cooling_capacity + "(GJ)"
	}else if(cool == '12'){
		obj.coolingCapacity = data.cooling_capacity + "(10GJ)"
	}else if(cool == '13'){
		obj.coolingCapacity = data.cooling_capacity + "(100GJ)"
	}else{
		obj.coolingCapacity = data.cooling_capacity
	}
	//累计热量
	let heat
	if(obj._data.heating_capacity_unit){
		heat = obj._data.heating_capacity_unit.toString(16)
	}else{
		heat = 'hh'
	}
	if(heat =='2' ){
		obj.heatingCapacity = data.heating_capacity + "(Wh)"
	}else if(heat == '3'){
		obj.heatingCapacity = data.heating_capacity + "(10Wh)"
	}else if(heat == '4'){
		obj.heatingCapacity = data.heating_capacity + "(100Wh)"
	}else if(heat == '5'){
		obj.heatingCapacity = data.heating_capacity + "(KWh)"
	}else if(heat == 'b'){
		obj.heatingCapacity = data.heating_capacity + "(KJ)"
	}else if(heat == 'c'){
		obj.heatingCapacity = data.heating_capacity + "(10KJ)"
	}else if(heat == 'd'){
		obj.heatingCapacity = data.heating_capacity + "(100KJ)"
	}else if(heat == 'e'){
		obj.heatingCapacity = data.heating_capacity + "(MJ)"
	}else if(heat == 'f'){
		obj.heatingCapacity = data.heating_capacity + "(10MJ)"
	}else if(heat == '10'){
		obj.heatingCapacity = data.heating_capacity + "(100MJ)"
	}else if(heat == '11'){
		obj.heatingCapacity = data.heating_capacity + "(GJ)"
	}else if(heat == '12'){
		obj.heatingCapacity = data.heating_capacity + "(10GJ)"
	}else if(heat == '13'){
		obj.heatingCapacity = data.heating_capacity + "(100GJ)"
	}else{
		obj.heatingCapacity = data.heating_capacity
	}
	//  功率
	let powerunit
	if(obj._data.power_unit){
		powerunit = obj._data.power_unit.toString(16)
	}else{
		powerunit = 'hh'
	}
	if(powerunit =='14' ){
		obj.power = data.power + "(W)"
	}else if(powerunit == '15'){
		obj.power = data.power + "(10W)"
	}else if(powerunit == '16'){
		obj.power = data.power + "(100W)"
	}else if(powerunit == '17'){
		obj.power = data.power + "(KWh)"
	}else{
		obj.power = data.power
	}
	//  瞬时流量
	let inst
	if(obj._data.instant_discharge_unit){
		inst = obj._data.instant_discharge_unit.toString(16)
	}else{
		inst = 'hh'
	}
	if(inst == '2f'){
		obj.instantDischarge = data.instant_discharge + "(mL/h)"
	}else if(inst == '30'){
		obj.instantDischarge = data.instant_discharge + "(10mL/h)"
	}else if(inst == '31'){
		obj.instantDischarge = data.instant_discharge + "(100mL/h)"
	}else if(inst == '32'){
		obj.instantDischarge = data.instant_discharge + "(L/h)"
	}else if(inst == '33'){
		obj.instantDischarge = data.instant_discharge + "(10L/h)"
	}else if(inst == '34'){
		obj.instantDischarge = data.instant_discharge + "(100L/h)"
	}else if(inst == '35'){
		obj.instantDischarge = data.instant_discharge + "(m/h)"
	}else{
		obj.instantDischarge = data.instant_discharge
	}
	//  累计流量
	let disc
	if(obj._data.discharge_unit){
		disc = obj._data.discharge_unit.toString(16)
	}else{
		disc = 'hh'
	}
	
	if(disc == '26'){
		obj.discharge = data.discharge + "(mL)"; 
	}else if(disc == '27'){
		obj.discharge = data.discharge + "(10mL)"; 
	}else if(disc == '28'){
		obj.discharge = data.discharge + "(100mL)"; 
	}else if(disc == '29'){
		obj.discharge = data.discharge + "(L)"; 
	}else if(disc == '2a'){
		obj.discharge = data.discharge + "(10L)"; 
	}else if(disc == '2b'){
		obj.discharge = data.discharge + "(100L)"; 
	}else if(disc == '2c'){
		obj.discharge = data.discharge + "(m³)"; 
	}else{
		obj.discharge = data.discharge
	}
	
 //    obj.coolingCapacity = data.cooling_capacity + "(kwh)";   //  累计冷量
 //    obj.heatingCapacity = data.heating_capacity + "(kwh)";   //  累计热量
	
 //    obj.power = data.power + "(kwh)";              //  功率
 //    obj.instantDischarge = data.instant_discharge + "(m²/h)"; //  瞬时流量
 //    obj.discharge = data.discharge + "(m²/h)";                 //  累计流量
	
    obj.inTemperature = data.in_temperature + "(℃)";       //  供水温度
    obj.cycleTemperature = data.cycle_temperature + "(℃)"; //  回水温度
    obj.uptime = data.uptime + "(H)";                       //  运行时间
    obj.time = data.time;                           //  当前时间
    obj.date = data.date;                           //  当前日期
    obj._status = data.status;                        // 状态

    return obj;
}